export const LIST_USERS = 'LIST_USERS';
export const LIST_USERS_SUCCESS = 'LIST_ALL_USERS_SUCCESS';
export const LIST_USERS_FAILURE = 'LIST_ALL_USERS_FAILURE';